export const FaqsData = [
    {
        "id": 1,
        "question_hindi": "Does DTDB offer facial services at home?",
        "answer_hindi": "Yes, at DTDB, we provide professional facial services in the comfort of your own home. Our skilled estheticians bring the spa experience to you, offering a range of facial treatments tailored to your skin's needs. Enjoy luxurious pampering without ever having to step foot outside.",
        "question": "Does DTDB offer facial services at home?",
        "answer": "Yes, at DTDB, we provide professional facial services in the comfort of your own home. Our skilled estheticians bring the spa experience to you, offering a range of facial treatments tailored to your skin's needs. Enjoy luxurious pampering without ever having to step foot outside.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 2,
        "question_hindi": "Does DTDB offer makeup services at home?",
        "answer_hindi": "Absolutely! At DTDB, we bring professional makeup services directly to your doorstep. Whether it's for a special occasion or just to glam up your day, our talented makeup artists are ready to enhance your natural beauty in the comfort of your own home.",
        "question": "Does DTDB offer makeup services at home?",
        "answer": "Absolutely! At DTDB, we bring professional makeup services directly to your doorstep. Whether it's for a special occasion or just to glam up your day, our talented makeup artists are ready to enhance your natural beauty in the comfort of your own home.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 3,
        "question_hindi": "Are online payments accepted by Door to Door Beauty?",
        "answer_hindi": "Yes, Door to Door Beauty accepts online payments, offering you a convenient and hassle-free way to settle your transactions securely from the comfort of your own home.",
        "question": "Are online payments accepted by Door to Door Beauty?",
        "answer": "Yes, Door to Door Beauty accepts online payments, offering you a convenient and hassle-free way to settle your transactions securely from the comfort of your own home.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 4,
        "question_hindi": "Is your Home DTDB beautician, is reliable and well-professional?",
        "answer_hindi": "Yes, our Door-to-Door Beauty (DTDB) beauticians are highly reliable and well-professional. They undergo rigorous training and adhere to strict standards to ensure top-quality service delivery. You can trust our team to provide exceptional beauty treatments with professionalism and expertise, right in the comfort of your own home.",
        "question": "Is your Home DTDB beautician, is reliable and well-professional?",
        "answer": "Yes, our Door-to-Door Beauty (DTDB) beauticians are highly reliable and well-professional. They undergo rigorous training and adhere to strict standards to ensure top-quality service delivery. You can trust our team to provide exceptional beauty treatments with professionalism and expertise, right in the comfort of your own home.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 5,
        "question_hindi": "What is DTDB Door to Door Beauty?",
        "answer_hindi": "DTDB Door to Door Beauty offers professional beauty services at your home, delivering luxury treatments like facials, hair styling, and makeup right to your doorstep.",
        "question": "What is DTDB Door to Door Beauty?",
        "answer": "DTDB Door to Door Beauty offers professional beauty services at your home, delivering luxury treatments like facials, hair styling, and makeup right to your doorstep.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 6,
        "question_hindi": "Which areas do you serve?",
        "answer_hindi": "We provide door-to-door beauty services across major cities. Check our website for specific coverage areas or contact us directly to confirm availability in your location.",
        "question": "Which areas do you serve?",
        "answer": "We provide door-to-door beauty services across major cities. Check our website for specific coverage areas or contact us directly to confirm availability in your location.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 7,
        "question_hindi": "How do I book a service?",
        "answer_hindi": "Booking is easy! Visit our website, select the services you want, choose a convenient time, and confirm your appointment. You can also book via phone or email.",
        "question": "How do I book a service?",
        "answer": "Booking is easy! Visit our website, select the services you want, choose a convenient time, and confirm your appointment. You can also book via phone or email.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 8,
        "question_hindi": "What services does DTDB offer?",
        "answer_hindi": "We offer a wide range of beauty treatments including haircuts, hairstyling, facials, manicures, pedicures, makeup, and more—all from the comfort of your home.",
        "question": "What services does DTDB offer?",
        "answer": "We offer a wide range of beauty treatments including haircuts, hairstyling, facials, manicures, pedicures, makeup, and more—all from the comfort of your home.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 9,
        "question_hindi": "Are your beauticians qualified?",
        "answer_hindi": "Yes, all our beauticians are certified professionals with extensive experience, ensuring top-quality service every time you book with us.",
        "question": "Are your beauticians qualified?",
        "answer": "Yes, all our beauticians are certified professionals with extensive experience, ensuring top-quality service every time you book with us.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 10,
        "question_hindi": "What safety measures do you follow?",
        "answer_hindi": "Our team follows strict hygiene protocols, including wearing masks, sanitizing tools, and maintaining cleanliness to ensure a safe and comfortable experience for all clients.",
        "question": "What safety measures do you follow?",
        "answer": "Our team follows strict hygiene protocols, including wearing masks, sanitizing tools, and maintaining cleanliness to ensure a safe and comfortable experience for all clients.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 11,
        "question_hindi": "Can I reschedule or cancel my appointment?",
        "answer_hindi": "Yes, you can reschedule or cancel your appointment easily. We recommend notifying us 24 hours in advance to avoid any cancellation fees.",
        "question": "Can I reschedule or cancel my appointment?",
        "answer": "Yes, you can reschedule or cancel your appointment easily. We recommend notifying us 24 hours in advance to avoid any cancellation fees.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 12,
        "question_hindi": "How do I pay for my service?",
        "answer_hindi": "We accept multiple payment options, including credit/debit cards, online banking, and digital wallets. Payments can be made securely online after the service is completed.",
        "question": "How do I pay for my service?",
        "answer": "We accept multiple payment options, including credit/debit cards, online banking, and digital wallets. Payments can be made securely online after the service is completed.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 13,
        "question_hindi": "Do you offer group bookings for events?",
        "answer_hindi": "Yes, we provide beauty services for special events like weddings, parties, and corporate events. Group bookings are available with customizable packages.",
        "question": "Do you offer group bookings for events?",
        "answer": "Yes, we provide beauty services for special events like weddings, parties, and corporate events. Group bookings are available with customizable packages.",
        "is_deleted": false,
        "is_active": true
    },
    {
        "id": 14,
        "question_hindi": "What if I’m not satisfied with my service?",
        "answer_hindi": "Your satisfaction is our priority. If you're not happy with the service provided, please contact us immediately, and we'll work to resolve the issue to your satisfaction.",
        "question": "What if I’m not satisfied with my service?",
        "answer": "Your satisfaction is our priority. If you're not happy with the service provided, please contact us immediately, and we'll work to resolve the issue to your satisfaction.",
        "is_deleted": false,
        "is_active": true
    }
  ];